import React from 'react'
import ContactUsForm from '../components/ContactUsForm'
import V2Layout from '../components/V2Layout'
import SEO from '../components/SEO'
import useCompanyStats from '../components/useCompanyStats'
import './ContactUsScreen.css'

const ContactUsScreen = () => {
    const { stats } = useCompanyStats()
    return (
        <V2Layout pageClass="pfc-contact">
            <SEO
                title="Contact Us"
                description="Tell us about your project. Our engineering team is ready to find the right fluid control solution for your application."
            />

            <section className="pfc-contact-hero">
                <div className="pfc-contact-hero-inner">
                    <p className="v2-section-label">Get in Touch</p>
                    <h1 className="pfc-contact-hero-title">How Can We Help You?</h1>
                    <p className="pfc-contact-hero-sub">
                        Tell us about your project. Our engineering team is ready to find
                        the right fluid control solution for your application.
                    </p>
                </div>
            </section>

            <section className="pfc-info-bar">
                <div className="pfc-info-bar-inner">
                    <div className="pfc-info-item">
                        <span className="pfc-info-label">Address</span>
                        <span className="pfc-info-value">1751 Aviation Blvd, Suite 100 · Lincoln, CA 95648</span>
                    </div>
                    <div className="pfc-info-divider" />
                    <div className="pfc-info-item">
                        <span className="pfc-info-label">Phone</span>
                        <a href="tel:+19166263029" className="pfc-info-value pfc-info-link">+1 (916) 626-3029</a>
                    </div>
                </div>
            </section>

            <section className="v2-content">
                <div className="v2-content-inner pfc-contact-body">

                    <div className="v2-content-col">
                        <p className="v2-section-label">Send a Message</p>
                        <h2 className="v2-content-title">Tell Us About Your Project</h2>
                        <p className="v2-content-body">
                            Fill out the form and we&apos;ll get back to you within 1-2 business days.
                        </p>
                        <div className="pfc-form-wrap">
                            <ContactUsForm />
                        </div>
                    </div>

                    <div className="v2-content-col">
                        <p className="v2-section-label">Our Facility</p>
                        <h2 className="v2-content-title">Visit Us in Lincoln, CA</h2>
                        <p className="v2-content-body">
                            Our {stats.facility_size_full} sq ft facility houses state-of-the-art Mazak live-tool lathes,
                            a {stats.cleanroom_size} sq ft third party-certified ISO 7 (Class 10,000) hard-wall clean room, an {stats.clean_work_area} sq ft clean work area, and dedicated testing equipment.
                        </p>
                        <div className="pfc-map-wrap">
                            <iframe
                                title="PFC Location"
                                width="100%"
                                height="100%"
                                src="https://maps.google.com/maps?q=1751%20aviation%20blvd&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                frameBorder="0"
                                scrolling="no"
                            />
                        </div>
                        
                    </div>

                </div>
            </section>

        </V2Layout>
    )
}

export default ContactUsScreen
